import React, { useState } from 'react';
import { translate } from '../Services/translation';

const SelectCountryAndCompanyLogin = ({ countries, orgs }) => {
    const [selectedCountry, setSelectedCountry] = useState("");
    const [selectedOrganization, setSelectedOrganization] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const countryChangeHandler = (event) => {
        const selectedCountryCode = event.target.value;
        setSelectedCountry(selectedCountryCode);

        resetCountryInput();
    };

    function resetCountryInput() {
        setSelectedOrganization("");
    }

    const orgChangeHandler = (event) => {
        const selectedOrgId = event.target.value;
        setSelectedOrganization(selectedOrgId);
    };

    const handleLinkClick = (event) => {
        if (!selectedOrganization) {
            event.preventDefault();
            setErrorMessage(translate('validation.error.organdcountry'));
        }
    };
    // Filter organizations based on the selected country
    const filteredOrganizations = selectedCountry ? orgs
            .filter(org => org?.Fields?.hasOwnProperty('CustomerDimensionCountry'))
            .filter(org => org?.Fields?.CustomerDimensionCountry['*'] === selectedCountry)
            .sort((a, b) => a.Fields._nameInvariantCulture['*'].localeCompare(b.Fields._nameInvariantCulture['*']))
        : [];

    const isDisabled = !selectedOrganization;

    function getOptionName(organization){
        const city = organization?.Addresses[0]?.City;

        if(city){
            return `${organization.Fields._nameInvariantCulture['*']} (${organization?.Addresses[0]?.City})`;
        }

        return organization.Fields._nameInvariantCulture['*'];
    }

    return (
        <form className="form__login-container--item">
                <div className="container">
                    <label className="form__label">
                        {translate("apply.select.country")}
                    </label>
                    <select onChange={countryChangeHandler} value={selectedCountry} className="form__input">
                    <option value="">{translate("apply.select.country.option")}</option>
                        {countries
                            .sort((a, b) => (a?.RegionInfo?.EnglishName  ?? a?.EnglishName).localeCompare(b?.RegionInfo?.EnglishName ?? b.EnglishName))
                            .map((country, index) => (
                            <option key={index} value={country.TwoLetterISOCode}>
                                {country?.RegionInfo?.EnglishName ?? country?.EnglishName}
                            </option>
                        ))}
                     </select>
                </div>

                <div className="container">
                    <label className="form__label" >
                      {translate("apply.select.organization")}
                    </label>
                    <select onChange={orgChangeHandler} value={selectedOrganization} className="form__input">
                    <option value="">{translate("apply.select.organization")}</option>
                        {filteredOrganizations.map((organization, index) => (
                            <option key={organization + index} value={organization.Id}>
                                {getOptionName(organization)}
                            </option>
                        ))}
                    </select>
                </div>

            <a type="button" className="form__button form__button--expand" href={isDisabled ? null : `/Registration?organizationName=${selectedOrganization}`} onClick={handleLinkClick} disabled={isDisabled}>
                    {translate("apply.for.account")}
            </a>
            {errorMessage && <p className="registration__error">{errorMessage}</p>}
        </form>

    );
};

export default SelectCountryAndCompanyLogin;
